<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="col-6">
                <h4 class="card-title">Kullanıcı Listesi</h4>
              </div>
              <div style="text-align: right;" class="col-6 card-title">
                <a style="color:#fff" href="/#/admin/user">
                  <button type="submit" class="btn btn-info btn-fill float-right">
                    Yeni Kullanıcı
                  </button>
                </a>
              </div>
              <!--<p class="card-category">Here is a subtitle for this table</p>-->
            </template>
            <a-table rowKey="id" :columns="columns" :data-source="users.users">
              <a slot="roles" slot-scope="text, record">
                <a-tag color="blue">{{roles.find(item => item.key == record.roles[0]).value}}</a-tag>
              </a>
              <a slot="action" slot-scope="text, record" class="actions-area">
                <a-button type="dashed" :href="'/#/admin/user/'+record.id"> <a-icon type="edit" /> </a-button>
                <a-tooltip v-if="record.id === currentUserId" title="Kendi hesabınızı silemezsiniz">
                  <a-button type="danger" disabled> <a-icon type="delete" /> </a-button>
                </a-tooltip>
                <a-popconfirm
                  v-else
                  @confirm="confirmDelete(record.id)"
                  title="Silmek istediğinize emin misiniz?"
                  ok-text="Evet"
                  cancel-text="Hayır">
                  <a-button type="danger"> <a-icon type="delete" /> </a-button>
                </a-popconfirm>
              </a>
            </a-table>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex"
  import Card from 'src/components/Cards/Card.vue'
  import roleList from '../../plugins/roles.json'
  export default {
    components: {
      Card
    },
    computed: {
      ...mapState({
        users: state => state.Users.users
      }),
      roles(){
        return roleList
      },
      currentUserId() {
        const profile = JSON.parse(localStorage.getItem('user') || 'null')
        return profile ? profile.id : null
      },
    },
    mounted() {
      console.log("mounted users")
      const self = this
      self.$store.dispatch("Users/requestUserList")
    },
    methods: {
      confirmDelete(user_id){
        const self = this
        self.$store.dispatch("Users/requestUserDelete", user_id).then(()=> {
          self.$notification['success']({
            message: 'Kullanıcı Silme',
            description:
              'Kullanıcı başarılı bir şekilde silindi 😊',
          });
        })
      }
    },
    data () {
      return {
        columns: [
          { title: 'ID', dataIndex: 'id', key: 'id'},
          { title: 'İsim', dataIndex: 'name', key: 'name'},
          { title: 'Soyisim', dataIndex: 'last_name', key: 'last_name'},
          { title: 'Email', dataIndex: 'email', key: 'email'},
          { title: 'Yetki Türü', dataIndex: 'roles', key: 'roles',scopedSlots: { customRender: 'roles' },},
          {
            title: 'Action',
            key: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'action' },
          },
        ]
      }
    }
  }
</script>
<style>
</style>
